import { NgModule } from '@angular/core';
import { RouterModule, Routes, ActivatedRouteSnapshot, RouterStateSnapshot, RouteReuseStrategy } from '@angular/router';
import { CustomRouteReuseStrategy } from './custom-route-reuse.strategy';
import { EditCollectionComponent } from './pages/edit-collection/edit-collection.component';
import { ServiceSettingsComponent } from './pages/service-settings/service-settings.component';
import { LibraryComponent } from './pages/library/library.component';
import { StoreComponent } from './pages/store/store.component';
import { HomeComponent } from './pages/home/home.component';
import { Error404Component } from './pages/error404/error404.component';
import { AuthGuard } from './shared/providers/auth.guard';
import { PortfolioComponent } from './pages/portfolio/portfolio.component';
import { MobileSharedUserContentComponent } from './mobile/mobile-shared-user-content/mobile-shared-user-content.component';
import { Landing2025Component } from './shared/components/landing2025/landing2025.component';
import { ClassicLandingComponent } from './shared/components/classic-landing/classic-landing.component';
import { PrivacyPolicyComponent } from './web/privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './web/terms-of-service/terms-of-service.component';

const routes: Routes = [
  // {path: 'ourway', canActivate: [RedirectGuard], component: RedirectGuard, data: { externalUrl: 'https://about.3dway.io/'} },
  // {path: 'status3dwayio', canActivate: [RedirectGuard], component: RedirectGuard, data: { externalUrl: 'https://status.3dway.io'} },
  // {path: 'about3dwayio', canActivate: [RedirectGuard], component: RedirectGuard, data: { externalUrl: 'https://about.3dway.io/'} },
  // {path: 'careers3dwayio', canActivate: [RedirectGuard], component: RedirectGuard, data: { externalUrl: 'https://careers.3dway.io'} },
  { path: 'landing2025', component: Landing2025Component },
  { path: 'classic-landing', component: ClassicLandingComponent },
  { path: 'new-landing', redirectTo: 'landing2025', pathMatch: 'full' },
  { path: 'get-started', component: Landing2025Component},
  {path: '', component: StoreComponent, data: {animation: 'homePageAnimation'}},
  {path: 'home', component: HomeComponent, pathMatch: 'full'},
  {path: 'model/:modelId', component: MobileSharedUserContentComponent },
  {path: 'collection/:collectionId', component: MobileSharedUserContentComponent },
  {path: 'library/edit', component: EditCollectionComponent, data: {animation: 'editCollectionPageAnimation'}},
  {path: 'library', component: LibraryComponent, data: {animation: 'libraryPageAnimation'}},

  {path: 'portfolio', component: PortfolioComponent, data: {animation: 'homePageAnimation'}},
  {path: 'pending-review', component: PortfolioComponent, data: {animation: 'homePageAnimation', reviewMode: true}},
  {path: 'in-review', component: PortfolioComponent, data: {animation: 'homePageAnimation', reviewMode: true, adminReviewMode: true}},
  {path: 'service', component: ServiceSettingsComponent},

  { path: 'legal/privacy-policy', component: PrivacyPolicyComponent },  // No guard here
  { path: 'legal/privacy', component: PrivacyPolicyComponent },  // No guard here
  { path: 'legal/terms-of-service', component: TermsOfServiceComponent },  // No guard here
  { path: 'legal/terms', component: TermsOfServiceComponent },  // No guard here

  {path: '404', component: Error404Component},
  // TEMPORARY REDIRECT TO TODAY SCREEN AS DEFAULT
  {path: '**', redirectTo: ''}

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top', onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
  providers: [
    {
        provide: 'externalUrlRedirectResolver',
        useValue: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
            window.location.href = (route.data as any).externalUrl;
        }
    },
    { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy }
  ]
})
export class MobileRoutingModule {
}
